<template>
  <v-tooltip top>
    <v-btn fab dark small color="amber darken-2" slot="activator" @click="add()">
      <v-icon>add</v-icon>
    </v-btn>
    <span>Add</span>
  </v-tooltip>
</template>

<script>
export default {
  methods: {
    add() {
      this.$emit("add");
    }
  }
};
</script>

<style>
</style>
